import useDeepCompareEffect from "use-deep-compare-effect";
import {LOCKS_SETUP, useProgressDispatch} from "./progressContext";

export const useSetupLocks = data => {
    const progressDispatch = useProgressDispatch()
    const safeData = data || {}

    useDeepCompareEffect(
        () => {
            if(safeData.sections) {
                let locks = []
                const sortedSections = [...safeData.sections].sort((a, b) => (a.order || 0) - (b.order || 0))
                sortedSections.forEach((section, sectionIndex) => {
                    (section.containers || []).forEach((container, containerIndex) => {
                        (container.blocks || []).forEach((block, blockIndex) => {
                            if(block.locked === true) {
                                locks.push({
                                    sectionId: sectionIndex,
                                    containerId: containerIndex,
                                    blockId: blockIndex
                                })
                            }
                        })
                    })
                })

                progressDispatch({
                    type: LOCKS_SETUP,
                    payload: locks
                })
            }

        }, [safeData]
    )

}